import { createReducer, on, Action } from '@ngrx/store';

import { fromCheckoutActions } from './checkout.actions';
import { QuotePaymentViewDto, BucketCard, CreditPack } from '@marketplace/api';

export interface CheckoutState {
  selectedCreditBundle: CreditPack;
  specialCreditBundle: CreditPack;
  creditBundles: CreditPack[];
  cards: BucketCard[];
  quoteToSend: QuotePaymentViewDto;
}

export const initialCheckoutState: CheckoutState = {
  selectedCreditBundle: undefined,
  specialCreditBundle: undefined,
  creditBundles: undefined,
  quoteToSend: undefined,
  cards: undefined
};

const reducer = createReducer(
  initialCheckoutState,
  on(fromCheckoutActions.setSelectedCreditBundle, (state, { payload }) => ({
    ...state,
    selectedCreditBundle: payload
  })),
  on(fromCheckoutActions.setQuoteToSend, (state, { payload }) => ({
    ...state,
    quoteToSend: payload
  })),
  on(fromCheckoutActions.setCreditBundles, (state, { payload }) => ({
    ...state,
    creditBundles: payload
  })),
  on(fromCheckoutActions.setCards, (state, { payload }) => ({
    ...state,
    cards: payload
  })),
  on(fromCheckoutActions.setSpecialCreditBundle, (state, { payload }) => ({
    ...state,
    specialCreditBundle: payload
  }))
);

export function checkoutReducer(state: CheckoutState, action: Action) {
  return reducer(state, action);
}
